<div #uploadDisplay id="tokenizer-upload" (pointerdown)="beginRotate($event)" (pointermove)="rotate($event)" (pointerup)="endRotate($event)" >
    <div class="floating-button-group left">
        <button mat-icon-button id="tokenizer-flip" aria-label="Flip Horizontal" (click)="flip('x')" >
            <mat-icon>swap_horiz</mat-icon>
        </button>
        <button mat-icon-button id="tokenizer-flip" aria-label="Flip Vertical" (click)="flip('y')" >
            <mat-icon>swap_vert</mat-icon>
        </button>
    </div>
    <div class="floating-button-group right">
        <button mat-icon-button id="tokenizer-reset" aria-label="Reset Token" (click)="recenter()" >
            <mat-icon>center_focus_strong</mat-icon>
        </button>
    </div>
    <div class="floating-button-group bottom right">
        <button mat-icon-button class="eyedrop" *ngIf="canEyedrop" (click)="eyedrop()">
            <mat-icon>colorize</mat-icon>
        </button>
    </div>
</div>
<div id="tokenizer-settings">
    <div id="tokenizer-picker">
    </div>
    <app-colorpicker [(color)]="color" [(alpha)]="alpha" [inline]="true" (colorChange)="updateColor()"></app-colorpicker>
    <div id="textures">
        @for (ring of ringTextures; track $index) {
            <img [src]="'./assets/textures/' + ring.source + '.png'" draggable="false" loading="lazy" class="lazy-img" (load)="$any($event.target).classList.add('loaded')" (click)="setTexture(ring)" />
        }
        <img [src]="'./assets/textures/null-ring-icon.png'" draggable="false" loading="lazy" class="null lazy-img" (load)="$any($event.target).classList.add('loaded')" (click)="setTexture()" />
    </div>
    <div style="display: flex;">
        <button mat-button (click)="import()" id="import-button">
            <mat-icon>save</mat-icon> <span>Save Token</span>
        </button>
    </div>
</div>
